import { render, staticRenderFns } from "./EditCourseArticle.vue?vue&type=template&id=0f846fbf&scoped=true&"
import script from "./EditCourseArticle.vue?vue&type=script&lang=js&"
export * from "./EditCourseArticle.vue?vue&type=script&lang=js&"
import style0 from "./EditCourseArticle.vue?vue&type=style&index=0&id=0f846fbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f846fbf",
  null
  
)

export default component.exports